<template>
  <div class="order-detail-info x-scrollbar-show" data-automation="OrderDetailInfo">
    <p class="detail-info-title">{{ orderInfo.title }}</p>

    <!-- 描述信息 -->
    <div class="detail-info-desc">
      <p :class="['detail-info-desc-txt', { 'detail-notexpansion': !isExpansion }]">
        {{ orderInfo.describe }}
      </p>
      <ux-button type="primary" text @click="changeExpansion">
        {{ isExpansion ? $t('HT.orderDetail.packUp') : $t('HT.orderDetail.unfold') }}
        <i :class="`${isExpansion ? 'ux_icon_arrow_up' : 'ux_icon_arrow_down'}`"></i>
      </ux-button>
    </div>

    <!-- 图片列表 -->
    <template v-if="imgList.length">
      <div class="detail-img-list" v-show="isExpansion">
        <ux-image
          v-for="img in imgList"
          class="detail-img"
          fit="cover"
          :key="img"
          :src="img"
          :preview-src-list="imgList"
        >
          <div slot="placeholder" class="detail-img-placeholder"></div>
        </ux-image>
      </div>
    </template>

    <p class="detail-info-footer">
      <span class="detail-info-time">{{$t('HT.createdTime')}}: {{ orderInfo.create_time }}</span>
      <span class="detail-imgnum">
        <i class="detail-img-icon ux_icon_picture"></i>
        <span>{{ imgList.length }}</span>
      </span>
    </p>
  </div>
</template>

<script>
export default {
  name: 'OrderDetailInfo',
  components: {},
  props: {
    orderInfo: {
      type: Object,
      default: () => {
        return {};
      }
    },
    // 展开全部
    isExpansion: {
      type: Boolean,
      default: false
    }
  },
  data() {
    return {};
  },
  computed: {
    imgList() {
      const img = this.orderInfo.img;
      return img ? img.split(',') : [];
    }
  },
  methods: {
    changeExpansion() {
      this.$emit('change-expansion');
    }
  }
};
</script>

<style lang="scss" scoped>
.order-detail-info {
  width: 100%;
  overflow: auto;
  position: relative;
  margin-bottom: 20px;

  .detail-info-title {
    height: 38px;
    font-size: 18px;
    font-weight: 600;
    line-height: 26px;
    color: $color-title;
  }

  .detail-info-desc {
    width: 100%;
    display: flex;
    overflow: hidden;
    margin-bottom: 12px;
    align-items: flex-start;
    justify-content: space-between;

    .ux-button {
      flex: 0 0 auto;
      margin-left: 48px;
      line-height: 20px;
    }
  }

  .detail-info-desc-txt {
    flex: 1;
    font-size: 14px;
    color: $color-title;

    &.detail-notexpansion {
      height: 20px;
      overflow: hidden;
      white-space: nowrap;
      text-overflow: ellipsis;
      -o-text-overflow: ellipsis;
    }
  }

  .detail-info-footer {
    color: $color-text-secondary;
    height: 16px;
    font-size: 12px;
    font-weight: 400;
    line-height: 16px;
    display: flex;
    align-items: center;

    .detail-imgnum {
      display: flex;
      align-items: center;
    }

    .detail-info-time {
      padding-right: 32px;
    }

    .detail-img-icon {
      font-size: 16px;
      margin-right: 4px;
    }
  }

  .detail-img-list {
    margin-bottom: 16px;
  }

  .detail-img {
    position: relative;
    background: #fff;
    margin-right: 16px;
    height: 80px;
    width: 80px;
  }

  .detail-img-placeholder {
    width: 100%;
    height: 100%;
    background: url('~@/assets/images/web/img-placeholder.png') no-repeat center center / content;
  }
}
</style>
